import HttpFactory from "../factory";

class LogModule extends HttpFactory {
  async referralOpen() {
    return await this.call("/api/ct_log/referral-open", "get");
  }
}

export default LogModule;
